import axios from "axios";
import config from "../config";

export const getPurchases = async (token, start = 0, from, to) => {
  let query = `${config.SERVER_URL}/purchases/?_start=${start}`;
  if(from) {
    query = query + `&from=${from}`
  }
  if(to) {
    query = query + `&to=${to}`
  }
  try {
    const response = await axios({
      method: "get",
      url: query,
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return [null, response];
  } catch (error) {
    return [error];
  }
};
